import { useMediaQuery, useTheme } from '@mui/material';

// Which navigation the layout shows. The bands are the theme's md (900) and
// lg (1200) breakpoints:
//   bottom    < 900 px   phones and upright tablets: tab bar at the bottom
//   condensed 900-1199   landscape tablets, narrow windows: header, search icon
//   full      >= 1200    today's header, unchanged
export type NavMode = 'bottom' | 'condensed' | 'full';

export function useNavMode(): NavMode {
    const theme = useTheme();
    // noSsr: read matchMedia on the first render, so a phone never flashes
    // the desktop header before switching.
    const belowMd = useMediaQuery(theme.breakpoints.down('md'), {
        noSsr: true,
    });
    const belowLg = useMediaQuery(theme.breakpoints.down('lg'), {
        noSsr: true,
    });
    if (belowMd) return 'bottom';
    if (belowLg) return 'condensed';
    return 'full';
}
